import { render } from "./BuzonSugerencias.vue?vue&type=template&id=7d77e4bc&scoped=true"
import script from "./BuzonSugerencias.vue?vue&type=script&lang=js"
export * from "./BuzonSugerencias.vue?vue&type=script&lang=js"

import "./BuzonSugerencias.vue?vue&type=style&index=0&id=7d77e4bc&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d77e4bc"]])

export default __exports__